import { LoadIconWrapper, LoadingIcon } from "./LoadIcon.style";

const LoadIcon = () => {
    return (
        <LoadIconWrapper>
            <LoadingIcon />
        </LoadIconWrapper>
    );
};

export default LoadIcon;
